import { Controller } from '@hotwired/stimulus';

// Step 1 decides at click time whether leaving needs the dialog: the wizard persists the job
// ad before the step has rendered, so a draft exists from the start and says nothing about
// whether anyone has typed into it. Later steps always warn and open the dialog directly.
const HOUSEKEEPING = ['_method', 'authenticity_token', 'utf8', 'commit'];

export default class extends Controller {
  static values = { formId: String };

  confirm(event) {
    if (!this.formHasContent()) return;

    event.preventDefault();
    this.dialogFor(event.params.dialog)?.open();
  }

  dialogFor(id) {
    const dialog = document.getElementById(id);
    if (!dialog) return null;

    return this.application.getControllerForElementAndIdentifier(dialog, 'dialog-component');
  }

  formHasContent() {
    const form = document.getElementById(this.formIdValue);
    if (!form) return false;

    return Array.from(new FormData(form))
      .filter(([name]) => !HOUSEKEEPING.includes(name))
      .some(([, value]) => String(value).trim() !== '');
  }
}
